import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/MarketplaceAffiliateReportByInfluencer.graphql';
import { Query, QuerymarketplaceAffiliateReportByInfluencerArgs } from '../../__generated__/globalTypes';

export const useMarketplaceAffiliateReportByInfluencerQuery = (
  options?: QueryHookOptions<Query, QuerymarketplaceAffiliateReportByInfluencerArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerymarketplaceAffiliateReportByInfluencerArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useMarketplaceAffiliateReportByInfluencerLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerymarketplaceAffiliateReportByInfluencerArgs>
): QueryResult<Query, QuerymarketplaceAffiliateReportByInfluencerArgs> & {
  getMarketplaceAffiliateReportByInfluencer: LazyQueryExecFunction<
    Query,
    QuerymarketplaceAffiliateReportByInfluencerArgs
  >;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getMarketplaceAffiliateReportByInfluencer, result] = useLazyQuery<
    Query,
    QuerymarketplaceAffiliateReportByInfluencerArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getMarketplaceAffiliateReportByInfluencer, ...result };
};

export const useMarketplaceAffiliateReportByInfluencerPromiseQuery = () => {
  const client = useApolloClient();

  const getMarketplaceAffiliateReportByInfluencer = useCallback(
    (options?: Omit<QueryOptions<QuerymarketplaceAffiliateReportByInfluencerArgs, Query>, 'query'>) =>
      client.query<Query, QuerymarketplaceAffiliateReportByInfluencerArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getMarketplaceAffiliateReportByInfluencer };
};
// Suspense Query Hooks
export const useMarketplaceAffiliateReportByInfluencerSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerymarketplaceAffiliateReportByInfluencerArgs>
) => {
  const result = useSuspenseQuery<Query, QuerymarketplaceAffiliateReportByInfluencerArgs>(QUERY, {
    ...options
  });

  return result;
};
